import moment from 'moment-timezone';
import 'moment/locale/sr';

import {
  asLocalStorageField,
} from 'hive-admin/src/components/FieldLocalStorage';

import Types from '../modules/types'

moment.locale('sr');

export const columnCreatedAt = {
  path: 'createdAt',
  title: 'Napravljeno',
  sort: 'created',
  render: (record) => (
    moment(record.createdAt).locale('sr')).format('DD.MM.YYYY.'),
};

export const columnUpdatedAt = {
  path: 'updatedAt',
  title: 'Ažurirano',
  sort: 'updated',
  render: record => (
    moment(record.updatedAt).calendar(null, {
      sameElse: 'lll',
    })
  ),
};

export const filterSortCreatedUpdated = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  col: 12,
  VALUES_MAP: {
    createdDesc: { createdAt: -1 },
    createdAsc: { createdAt: 1 },
    updatedDesc: { updatedAt: -1 },
    updatedAsc: { updatedAt: 1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.createdDesc })
  ),
  getValueForField: value => (value && value.length ? value : undefined),
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sortiraj',
    defaultValue: 'createdDesc',
    initialValue: 'createdDesc',
    prepareValueForInput: value => (value ? value : 'createdDesc'),
    choices: [{
      label: '↓ Napravljeno',
      value: 'createdDesc',
    }, {
      label: '↑ Napravljeno',
      value: 'createdAsc',
    }, {
      label: '↓ Ažurirano',
      value: 'updatedDesc',
    }, {
      label: '↑ Ažurirano',
      value: 'updatedAsc',
    }],
  }],
}];

export const filterSortCreatedUpdatedName = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  col: 12,
  VALUES_MAP: {
    createdDesc: { createdAt: -1 },
    createdAsc: { createdAt: 1 },
    updatedDesc: { updatedAt: -1 },
    updatedAsc: { updatedAt: 1 },
    nameDesc: { name: 1 },
    nameAsc: { name: -1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.createdDesc })
  ),
  getValueForField: value => (value && value.length ? value : undefined),
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sortiraj',
    defaultValue: 'createdDesc',
    initialValue: 'createdDesc',
    prepareValueForInput: value => (value ? value : 'createdDesc'),
    choices: [{
      label: '↓ Napravljeno',
      value: 'createdDesc',
    }, {
      label: '↑ Napravljeno',
      value: 'createdAsc',
    }, {
      label: '↓ Ažurirano',
      value: 'updatedDesc',
    }, {
      label: '↑ Ažurirano',
      value: 'updatedAsc',
    }, {
      label: '↓ Ime',
      value: 'nameDesc',
    }, {
      label: '↑ Ime',
      value: 'nameAsc',
    }],
  }],
}];

export const filterSortHidden = ['FilterHidden', {
  id: 'sort',
  build: builder => builder.add('sort', { createdAt: -1 }),
}];

export const getValueForFieldDefault = value => (
  value && value.length
  ? value
  : undefined
);

export const fieldBlocks = ['FieldSortableList', {
  name: 'blocks',
  placeholder: 'Blocks',
  label: null,
  block: true,
  condensed: true,
  addButtonLabel: 'Add Block',
  fields: [
    ['FieldRadio', {
      name: 'type',
      label: null,
      block: true,
      initialValue: Types.PAGE_BLOCK_TYPE[0],
      choices: Types.PAGE_BLOCK_TYPE.map((id) => ({
        value: id,
        label: Types.PAGE_BLOCK_TYPE_MAP[id].label,
      })),
    }],
    ['FieldText', {
      name: 'title',
      label: null,
      placeholder: 'Title',
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'TITLE',
      ]],
    }],
    ['FieldRichText', {
      name: 'text',
      label: null,
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'TEXT',
      ]],
      menuBarButtons: [
        'bold',
        'italic',
        'strikethrough',
        'link',
        'separator',
        'heading1',
        'heading2',
        'heading3', // mrzim sto se ovo zove heading tbh iako sam ja smarao
        'separator',
        'unorderedList',
        'orderedList',
        'blockQuote',
        // 'separator',
        // 'image',
        // 'separator',
      ],
    }],
    ['FieldUploadRefsHorizontal', {
      name: 'image',
      label: null,
      maxCount: 1,
      listType: 'picture',
      uploadLabel: 'Upload',
      accept:
        'image/jpg,image/jpeg,image/png,image/webp',
      transformations: [
        ['GM', { command: 'compress', maxWidth: 2000 }],
      ],
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'IMAGE',
      ]],
    }],
    ['FieldRadio', {
      name: 'imageParallax',
      label: null,
      block: true,
      choices: [{
        value: true,
        label: 'Parallax',
      }, {
        value: false,
        label: 'Static',
      }],
      initialValue: true,
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'IMAGE',
      ]],
    }],
    ['FieldText', {
      name: 'actionLabel',
      label: null,
      placeholder: 'Label',
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'ACTION',
      ]],
    }],
    ['FieldText', {
      name: 'actionUrl',
      label: null,
      placeholder: 'Link',
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'ACTION',
      ]],
    }],
    ['FieldUploadRefsHorizontal', {
      name: 'modalImageInner',
      label: null,
      maxCount: 1,
      listType: 'picture',
      uploadLabel: 'Upload Image',
      accept:
        'image/jpg,image/jpeg,image/png,image/webp',
      transformations: [
        ['GM', { command: 'compress', maxWidth: 2000 }],
      ],
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'MODAL',
      ]],
    }],
    ['FieldText', {
      name: 'modalTitle',
      label: null,
      placeholder: 'Title',
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'MODAL',
      ]],
    }],
    ['FieldRichText', {
      name: 'modalText',
      label: null,
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'MODAL',
      ]],
      menuBarButtons: [
        'bold',
        'italic',
        'strikethrough',
        'link',
        'separator',
        'heading1',
        'heading2',
        'heading3', // mrzim sto se ovo zove heading tbh iako sam ja smarao
        'separator',
        'unorderedList',
        'orderedList',
        'blockQuote',
        // 'separator',
        // 'image',
        // 'separator',
      ],
    }],
    ['FieldText', {
      name: 'modalActionLabel',
      label: null,
      placeholder: 'Label',
      skip: [[
        'condition.testFieldValue',
        'type',
        '!==',
        'MODAL',
      ]],
    }],
  ],
}];

export const blocksFields = [
  asLocalStorageField(['FieldTitleToggle', {
    title: 'Blocks',
    subtitle: 'Setup your page blocks',
    name: 'showBlockFields',
    initialValue: false,
    virtual: [() => true],
  }]),
  [fieldBlocks[0], {
    ...fieldBlocks[1],
    hidden: [['condition.fieldIsNotTrue', 'showBlockFields']],
  }],
];

export const metaFields = [
  asLocalStorageField(['FieldTitleToggle', {
    title: 'Meta',
    subtitle: 'Setup meta fields for better SEO results',
    name: 'showMetaFields',
    initialValue: false,
    virtual: [() => true],
  }]),
  ['FieldText', {
    name: 'meta.title',
    label: null,
    placeholder: 'Title',
    hidden: [['condition.fieldIsNotTrue', 'showMetaFields']],
  }],
  ['FieldText', {
    name: 'meta.description',
    label: null,
    placeholder: 'Description',
    hidden: [['condition.fieldIsNotTrue', 'showMetaFields']],
  }],
  ['FieldUploadRefsHorizontal', {
    name: 'meta.image',
    label: null,
    maxCount: 1,
    listType: 'picture',
    uploadLabel: 'Upload',
    hidden: [['condition.fieldIsNotTrue', 'showMetaFields']],
    accept:
      'image/jpg,image/jpeg,image/png,image/webp',
    transformations: [
      ['GM', { command: 'compress', maxWidth: 200 }],
    ],
  }],
];
